import { render } from "./DashboardAiman.vue?vue&type=template&id=4f1d5af8&scoped=true"
import script from "./DashboardAiman.vue?vue&type=script&lang=js"
export * from "./DashboardAiman.vue?vue&type=script&lang=js"

import "./DashboardAiman.vue?vue&type=style&index=0&id=4f1d5af8&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1d5af8"]])

export default __exports__